module.exports = __webpack_public_path__ + "img/fw1.b681ec39.png";